// src/index.js
import React from "react";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "styled-components";
import theme from "./central/theme";
import GlobalStyle from "./central/GlobalStyle";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <AuthProvider>
      <App />
    </AuthProvider>
  </ThemeProvider>
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      // Store on window so UpdateBanner can read it even if mounted after this fires
      window.__swWaitingWorker = registration.waiting;
      window.dispatchEvent(
        new CustomEvent("swUpdate", { detail: registration.waiting })
      );
    }
  },
});